import { createContext, Dispatch, SetStateAction } from 'react';
import { PostItemType } from 'service/timeline';

interface ProfilePageContextType {
  pinPosts: PostItemType[];
  setPinPosts: Dispatch<SetStateAction<PostItemType[]>>;
}

const ProfilePageContext = createContext<ProfilePageContextType>({
  pinPosts: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPinPosts: () => {},
});

export default ProfilePageContext;
